import {
  Zap as ZapIcon,
  Code as CodeIcon,
  Copy as CopyIcon,
  Activity as LogIcon,
  Package as PackageIcon,
  Smartphone as SmartphoneIcon,
  Codesandbox as CodeSandboxIcon,
  Grid as GridIcon,
  Star as StarIcon,
  Users as UsersIcon
} from 'react-feather';

const menuItems = [
  {
    title: 'HOME',
    hide_title: true,
    items: [
      {
        href: '/app/ps-library',
        icon: StarIcon,
        title: 'PS Library',
        className: 'nav-ps-library',
        isEAP: true,
        key: 'ps-library',
        isNew: true
      }
    ]
  },
  {
    title: 'FEATURES',
    items: [
      {
        href: '/app/features/bootstrap-templates',
        icon: GridIcon,
        title: 'Bootstrap Templates',
        className: 'nav-templates'
      },
      {
        href: '/app/features/apps-marketplace',
        icon: CodeSandboxIcon,
        title: 'Apps Marketplace',
        className: 'nav-apps-marketplace'
      },
      {
        href: '/app/features/mobile-apps',
        icon: SmartphoneIcon,
        title: 'Mobile Apps',
        className: 'nav-mobile-apps',
        isNew: false
      },
      {
        href: '/app/features/services',
        icon: ZapIcon,
        title: 'Bootstrapper Services',
        className: 'nav-services'
      },
      {
        href: '/app/features/snippets',
        icon: CodeIcon,
        title: 'Snippets',
        className: 'nav-snippets',
        isNew: false
      }
    ]
  },
  {
    title: 'MANAGE',
    items: [
      {
        href: '/app/manage/zendesk-instances',
        icon: CopyIcon,
        title: 'Zendesk Instances',
        className: 'nav-instances'
      },
      {
        href: '/app/manage/my-collections',
        forward: true,
        title: 'My Collections',
        icon: PackageIcon,
        className: 'nav-collections'
      }
    ]
  },
  {
    title: 'REPORTS',
    items: [
      {
        href: '/app/reporting/logs',
        icon: LogIcon,
        hash: '#logs',
        title: 'Logs',
        className: 'nav-logs'
      }
    ]
  },
  {
    title: 'TEAM',
    hide_title: true,
    items: [
      {
        href: '/app/meet-the-team',
        icon: UsersIcon,
        title: 'Meet the Team',
        className: 'nav-home'
      }
    ]
  }
];

export default menuItems;
